import { h } from "preact";
import { t, translate } from "restaumatic-client";
function EditBlock(props) {
    const { type, title, description, footer, actionText, isInvalid = false, ariaLabel, onEdit, isEditable = true, } = props;
    const hasIcon = type === "icon" && !!props.icon;
    const hasImage = type === "image" && !!props.imageUrl;
    const hasDescription = !!description;
    const hasFooter = !!footer;
    const ctaLabel = actionText || translate(t.actions.change);
    const hasOnlyTitle = !hasDescription && !hasFooter;
    return (h("div", { class: `m-edit-block ${isInvalid ? "has-error" : ""}`, "aria-label": ariaLabel },
        hasIcon && (h("div", { class: `m-edit-block__icon ${!hasDescription ? "m-edit-block__icon--centered" : ""}`, "aria-hidden": "true" },
            h("i", { class: `icon-${props.icon} icon-base icon-among-text` }))),
        hasImage && (h("div", { class: "m-edit-block__image", "aria-hidden": "true" },
            h("img", { src: props.imageUrl, alt: "" }))),
        h("div", { class: "m-edit-block__content" },
            h("h5", { class: `m-edit-block__title ${hasOnlyTitle ? "u-text-normal" : ""}` }, title),
            hasDescription && (h("p", { class: "m-edit-block__description" }, description)),
            hasFooter && (h("div", { class: "m-edit-block__footer" },
                h("span", null, footer)))),
        isEditable && (h("div", { class: "m-edit-block__action" },
            h("button", { onClick: onEdit, class: "btn btn-link u-px2", type: "button", "aria-label": `${ctaLabel} ${ariaLabel}` }, ctaLabel)))));
}
export default EditBlock;
